import { React } from 'react';
import '../../../styles/fight/takerProcess/TakerGamePanel.scss';

function TakerGamePanel({ gameData, leftColor, rightColor }) {
  return (
    <div className='taker-game-panel'>
      <div
        className='panel'
        style={{
          '--left-color': leftColor,
          '--right-color': rightColor,
        }}>
        <div className='left-wrapper'>
          <div className='left-header'>
            <p className='left-label'>You</p>
          </div>
          <div className='piece left'>
            <h1>{gameData.takerTeamAcronym}</h1>
          </div>
        </div>

        <div className='gap'>
          <div className='panel-vs-circle'>
            <h1>vs</h1>
          </div>
        </div>

        <div className='right-wrapper'>
          <div className='right-header'>
            <p className='right-label'>{gameData.makerName}</p>
          </div>
          <div className='piece right'>
            <h1>{gameData.makerTeamAcronym}</h1>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TakerGamePanel;
